import React from 'react';
import CashNotReceivedUI from './components/CashNotReceivedUI';

const CashNotReceived = () => {
    return (
       <CashNotReceivedUI/>
    );
};

export default CashNotReceived;